<template>
  <div class="container-fluid" :class="themeClass" :style="backgroundStyle">
    <template v-if="!errorMessage">
      <div class="container">
        <div class="remaining">
          <div class="remaining__text" :style="remainingText">
            <template v-if="isInactive">{{ stateText }}</template>
            <template v-if="!isInactive">
              <span class="remaining__label">참여 횟수</span>
              <span class="remaining__number" :style="remainingNumberTextColorStyle">{{ rouletteCount }}</span>
            </template>
          </div>
        </div>
        <div class="roulette">
          <div class="roulette__pin">
            <svg width="48" height="80" viewBox="0 0 48 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24 0C10.744 0 0 11.622 0 25.9692C0 47.8242 24 80 24 80C24 80 48 47.8242 48 25.9692C48 11.622 37.256 0 24 0Z"
                :fill="userColorStyle"
              />
              <circle cx="24" cy="24" r="16" :fill="pinStyle" />
            </svg>
          </div>
          <ul ref="roulette" class="roulette__circle" :style="borderColorStyle" @transitionend="showPopup(1)">
            <li
              class="roulette__slice"
              v-for="(coupon, key) in coupons"
              :style="`${getBackgroundColor(key)}`"
              :key="key"
            >
              <div class="roulette__label" :style="labelTextColorStyle">{{ displayLabel(coupon) }}<br /></div>
            </li>
          </ul>
          <button class="roulette__spin-button spin-button" :disabled="isDisabled" @click="onSpin">
            <div class="spin-button__container" :style="spinBtnOuterShadowStyle">
              <div class="spin-button__outer">
                <div class="spin-button__inner" :style="spinBtnInnerStyle">
                  <div class="spin-button__background" :style="spinBtnInnerShadowStyle"></div>
                  <div class="spin-button__label" :style="orderTxtColorStyle">{{ orderTxt }}</div>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </template>
    <template v-if="errorMessage">
      <div class="container" style="font-size: 5rem; color: red; text-align: center">
        {{ errorMessage }}
      </div>
    </template>
    <popup
      :visible="settingsPopup.visible"
      :type="settingsPopup.type"
      :title="settingsPopup.title"
      :subtitle="settingsPopup.subtitle"
      :buttonText="'확인'"
      @close="callback"
    />
  </div>
</template>
<script>
import Popup from './../popup/app';
import api from './api';
import { ERRORS } from '../redeem-message';
import auth from '../auth';

export default {
  name: 'roulette-app',
  props: [
    'theme',
    'rouletteColor',
    'imageUrl',
    'paddingTop',
    'paddingBottom',
    'couponCode',
    'orderTxt',
    'orderTxtColor',
    'pageId',
  ],
  components: {
    Popup,
  },
  data() {
    return {
      userRouletteColor: this.rouletteColor,
      isReady: false,
      settingsPopup: {
        type: 'confirm',
        visible: false,
        title: '쿠폰 발급 완료',
        subtitle: '',
      },
      index: null,
      stock: 0,
      tmpStock: 0,
      expired: false,
      isInvalidCouponCode: false,
      isTargetPageIdForCouponCode: true,
      coupons: [],
      coupon: null,
      rouletteCount: 0,
      tmpRouletteCount: 0,
      metricOptions: [
        { field: 'discountRate', unit: '%' },
        { field: 'discountAmount', unit: '원' },
      ],
    };
  },
  mixins: [auth],
  computed: {
    errorMessage() {
      if (!this.isTargetPageIdForCouponCode) {
        return '이 쿠폰 코드는 이 페이지에서 사용할 수 없습니다. 쿠폰 코드를 확인해 주세요.';
      }
      if (this.isInvalidCouponCode) {
        return '유효하지 않은 쿠폰코드입니다.';
      }
      return '';
    },
    stateText() {
      if (!this.hasUserRouletteCount) {
        return '참여 횟수를 전부 소진했습니다.';
      }
      if (this.isOutOfStock) {
        return '쿠폰 재고가 전부 소진되었습니다.';
      }
      if (this.isExpired) {
        return '참여 기간이 만료된 이벤트 입니다.';
      }
      return '';
    },
    isInactive() {
      return !this.hasUserRouletteCount || this.isOutOfStock || this.isExpired;
    },
    hasUserRouletteCount() {
      return this.rouletteCount > 0;
    },
    isOutOfStock() {
      return this.stock === 0;
    },
    isExpired() {
      return this.expired;
    },
    isDisabled() {
      return !this.isReady || this.isInactive;
    },
    themeClass() {
      return `container-fluid--${this.theme}`;
    },
    backgroundStyle() {
      const padding = `padding-top: ${this.paddingTop / 10}rem; padding-bottom: ${this.paddingBottom / 10}rem;`;
      if (this.isInactive) {
        return padding;
      }
      return `background-image: url(${this.imageUrl});${padding}`;
    },
    spinBtnInnerStyle() {
      return `border: 0.1rem solid ${this.userRouletteColor};background: ${
        this.theme === 'light'
          ? `${this.userRouletteColor}b3`
          : `linear-gradient(0deg, ${this.userRouletteColor}cc, ${this.userRouletteColor}cc), #FFFFFF`
      };`;
    },
    remainingText() {
      if (!this.isInactive) {
        return;
      }
      return 'color: #aaaaaf';
    },
    remainingNumberTextColorStyle() {
      if (this.isInactive) {
        return;
      }
      return `color: ${this.userRouletteColor}`;
    },
    orderTxtColorStyle() {
      if (this.isInactive) {
        return `color: ${this.theme === 'light' ? '#ffffff' : '#aaaaaf'}`;
      }
      return `color: ${this.orderTxtColor}`;
    },
    labelTextColorStyle() {
      return `color: ${this.userRouletteColor}`;
    },
    borderColorStyle() {
      return `border: 0.3rem solid ${this.userRouletteColor}80;`;
    },
    spinBtnInnerShadowStyle() {
      return `box-shadow: inset 0 -2rem 4rem ${this.userRouletteColor}80, inset 0 -0.2rem 0.2rem ${this.userRouletteColor};`;
    },
    spinBtnOuterShadowStyle() {
      return `box-shadow: 0 0.6rem 3.2rem -0.4rem ${this.userRouletteColor}${this.theme === 'light' ? '80' : 'b3'};`;
    },
    pinStyle() {
      return `${this.theme === 'light' ? '#ffffff' : '#00000080'}`;
    },
    userColorStyle() {
      return `${this.userRouletteColor}`;
    },
  },
  created() {
    this.load();
  },
  methods: {
    displayLabel(coupon) {
      if (coupon.discountRate || (coupon.discountRate && coupon.discountAmount)) {
        const v = this.getCurrentMetric('discountRate');
        return `${new Intl.NumberFormat().format(coupon[v.field])}${v.unit}`;
      }
      const v = this.getCurrentMetric('discountAmount');
      return `${new Intl.NumberFormat().format(coupon[v.field])}${v.unit}`;
    },
    getBackgroundColor(index) {
      if (index % 2 === 0) {
        return `background-color: ${this.userRouletteColor}${this.theme === 'light' ? '1a' : '40'}`;
      }

      return `background-color: ${this.userRouletteColor}${this.theme === 'light' ? '33' : '1a'}`;
    },
    getCurrentMetric(field) {
      return this.metricOptions.find((metricOption) => metricOption.field === field);
    },
    updateUserRouletteColor() {
      if (this.isInactive) {
        this.userRouletteColor = this.theme === 'light' ? '#d3d3d3' : '#444444';
      }
    },
    async load() {
      try {
        const {
          data: {
            data: { rouletteItems: coupons, rouletteCount, stock, expired },
          },
        } = await api.getRouletteByRoulette(this.couponCode, this.pageId);
        this.coupons = coupons;
        this.stock = stock;
        this.expired = expired;
        this.rouletteCount = rouletteCount;
        this.isReady = true;

        this.updateUserRouletteColor();
      } catch (err) {
        switch (err.code) {
          case ERRORS.COUPON_EXPIRED:
            this.expired = true;
            break;
          case ERRORS.USER_COUPON_NOT_FOUND:
            this.isInvalidCouponCode = true;
            break;
          case ERRORS.COUPON_PAGEID_UNMATCHED:
            this.isTargetPageIdForCouponCode = false;
            break;
        }
      }
    },
    async onSpin() {
      try {
        this.isReady = false;
        const {
          data: {
            data: { coupon, rouletteCount, stock, expired },
          },
        } = await api.requestUserRedeemByRoulette(this.couponCode);
        const couponCode = coupon.code;
        const values = [330, 270, 210, 150, 90, 30];
        this.coupon = coupon;
        this.expired = expired;
        this.tmpStock = stock;
        this.tmpRouletteCount = rouletteCount;
        this.index = this.coupons.findIndex((coupon) => couponCode.includes(coupon.code));
        this.deg = 720 + values[this.index];
        this.settingsPopup.subtitle = `${coupon.title} - ${this.displayLabel(
          coupon
        )} 할인 쿠폰 발급이 완료되었습니다.<br>발급된 쿠폰은 <a href="/me/coupon"><span style="font-weight: bold;text-decoration: underline;">마이페이지 > 쿠폰</span></a>에서 확인하실 수 있습니다.`;

        requestAnimationFrame(() => {
          this.$refs.roulette.style.transition = 'all ease 3s';
          this.$refs.roulette.style.transform = `rotate(${this.deg}deg)`;
          this.$refs.roulette.classList.add('blur');
        });
      } catch (err) {
        // 에러 발생시 code와 message의 용도가 다르게 사용됨.
        // 상태 code를 auth에서는 message로 보여주고, coupon roulette api에서는 code에서 보여주고 있음.
        if (err && err.message === ERRORS.INVALID_ACCESS_TOKEN) {
          this.authorize('signIn', {
            message: '쿠폰 발급을 위해, 로그인 해주세요.',
          });
        }
        if (err && err.message !== ERRORS.INVALID_ACCESS_TOKEN) {
          switch (err.code) {
            case ERRORS.COUPON_EXPIRED:
              this.expired = true;
              break;
            case ERRORS.USER_COUPON_NOT_FOUND:
              this.isInvalidCouponCode = true;
              break;
            case ERRORS.COUPON_PAGEID_UNMATCHED:
              this.isTargetPageIdForCouponCode = false;
              break;
            case ERRORS.COUPON_ROULETTE_COUNT_ZERO:
              this.settingsPopup.title = '쿠폰 발급 실패';
              this.settingsPopup.subtitle = `룰렛 돌리기 횟수를 모두 사용 하였습니다!`;
              this.showPopup();
              break;
            case ERRORS.COUPON_ENGAGE_FAILED:
              this.settingsPopup.title = '쿠폰 발급 실패';
              this.settingsPopup.subtitle = `쿠폰 재고가 전부 소진되었습니다.`;
              this.showPopup();
              break;
            case ERRORS.COUPON_REDEEM_FAILED:
            default:
              this.settingsPopup.title = '쿠폰 발급 실패';
              this.settingsPopup.subtitle = `
                 불편을 드려 죄송합니다.<br/>
                 알 수 없는 오류로 쿠폰이 지급되지 않았습니다.<br/>
                 잠시 후 다시 시도해 주세요.
                `;
              this.showPopup();
          }
        }
      }
    },

    showPopup(sec = 0) {
      setTimeout(() => {
        this.settingsPopup.visible = true;
        this.isReady = true;
      }, sec * 1000);
    },
    callback() {
      this.$refs.roulette.classList.remove('blur');
      this.$refs.roulette.style.transition = 'none';
      this.$refs.roulette.style.transform = 'none';
      this.index = null;
      this.stock = this.tmpStock;
      this.rouletteCount = this.tmpRouletteCount;
      this.settingsPopup.visible = false;
      this.updateUserRouletteColor();
    },
  },
};
</script>
<style lang="scss" scoped>
.fc-layout-911[class^='fc-block'] {
  .container-fluid {
    .container {
      display: block;
    }
  }
}
</style>
